import React from "react";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import Colors from "../../shared/colors"
import NetIconMembro from '../../assets/images/Icons Network/ic-badge-membro.svg';
import NetIconInscrito from '../../assets/images/Icons Network/ic-badge.inscrito.svg';

const InputResult = (props) => (
    <span> 
        {
            props.to === "restaurants" &&
                <Link to={`/${props.i18n.language}/${props.t('restaurantes')}/${props.slug}`}>
                    <div className={props.className}>
                        <Image><img src={props.media[2][0].path} alt={props.name}/></Image>
                        <Info>
                            <Title>
                                {
                                    props.network === 1 &&
                                        <img src={NetIconMembro} alt=""/>
                                }
                                {
                                    props.network === 2 &&
                                        <img src={NetIconInscrito} alt=""/>
                                }
                                {props.name}
                            </Title>
                            <Location>
                                {props.country}                            
                            </Location>
                        </Info>
                    </div>
                </Link>
        }
        {
            props.to === "products" &&
                <Link to={`/${props.i18n.language}/${props.t('produtos')}/${props.slug}`}>
                    <div className={props.className}>
                        <Image><img src={props.media[4][0].path} alt={props.name}/></Image>
                        <Info>
                            <Title>{props.name}</Title>
                            <Location>{props.category && props.category.name}</Location>
                        </Info>
                    </div>
                </Link>
        }
        {
            props.to === "recipes" &&
                <Link to={`/${props.i18n.language}/${props.t('receitas')}/${props.slug}`}>
                    <div className={props.className}>
                        <Image><img src={props.media[2][0].path} alt={props.name}/></Image>
                        <Info>
                            <Title>{props.name}</Title>
                            <Date>
                                {props.category && props.category.name}
                            </Date>
                        </Info>
                    </div>
                </Link>
        }
    </span>
)

const InputResulthWithStyles = styled(InputResult) `
    display: flex; 
    align-items: center;
    width: 400px;
    padding: 15px;
    transition: all 0.2s ease;
    cursor: pointer;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    overflow: hidden;
    
    &:focus{
        border: 1px solid ${Colors.primary};
    }

    &:hover{
        background-color: ${Colors.background};
    }

    @media screen and (max-width: 830px) {
        width: 100%;
    }
`
const Image = styled.div `
    img {
        width: 50px;
        height: 50px;
        object-fit: cover;
        border-radius: 3px;
        border: 1px solid rgba(0,0,0,0.1);
    }
`
const Info = styled.div `
    margin-left: 10px;
    margin-top: -2px;
`
const Title = styled.div `
    font-size: 13px;
    font-weight: 600;
    color: #000;
    display: flex;
    align-items: center;

    img{
        margin-right: 5px;
    }
`
const Location = styled.div `
    font-size: 11px;
    color: ${Colors.text.secondary};
    margin-bottom:2px;
    margin-top: 2px;
`
const Date = styled.div `
    font-size: 12px;
    color: ${Colors.text.secondary};
    font-weight: 600;
`

export default InputResulthWithStyles;


// WEBPACK FOOTER //
// ./src/components/inputresult/inputresult.component.js